const Videos = {
  // Mobile - Updated to match actual file names
  hero_mobile_one: "/videos/mobile/hero_mobile_vid_one.mp4",
  hero_mobile_two: "/videos/mobile/hero_mobile_vid_two.mp4",
  hero_mobile_three: "/videos/mobile/hero_mobile_three.mp4",
  hero_mobile_four: "/videos/mobile/hero_mobile_four.mp4",
  hero_mobile_five: "/videos/mobile/hero_mobile_five.mp4",

  // Web - All files exist
  hero_web_one: "/videos/web/hero_web_one.mp4",
  hero_web_two: "/videos/web/hero_web_two.mp4",
  hero_web_three: "/videos/web/hero_web_three.mp4",
  hero_web_four: "/videos/web/hero_web_four.mp4",
  hero_web_five: "/videos/web/hero_web_five.mp4",
};

export default Videos;
